<template>
	<div class="layout-footer w-full">
		<div class="grid w-full">
			<div class="col-6">
				<span class="footer-text">
							Copyright &copy; {{ currentYear }} <b>Wilmar Group Indonesia</b>. All rights reserved.
							<span v-if="policyLink">
								&nbsp;|&nbsp;<a :href="policyLink" target="_blank" rel="noopener" class="footer-text">Privacy Policy</a>
							</span>
				</span>

			</div>
			<div class="col-6 text-right">
				<span class="footer-text">
					{{ version }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "AppFooter",
	data() {
		return {
			version: "[] V.0.0",
			policyLink: ''
		}
	},
	computed: {
		darkTheme() {
			return this.$appState.theme.startsWith('saga');
		},
		currentYear() {
			return new Date().getFullYear();
		}
	},
	beforeMount() {
		var self = this;
		this.$axios.get(this.$UTIL_URL + "version")
			.then((response) => {
				if (response && response.data.success) {
					self.version = response.data.data;
				}

			})
			.catch((error) => {
				//self.showError('Error Getting Order Type Data', error);
			});

		// Fetch Privacy Policy link from lookup list
		this.$axios.get(this.$API_URL + "list/lookup", { params: { group: 'LINK_FILE_POLICY' } })
			.then((response) => {
				if (response && response.data) {
					const raw = response.data;
					const payload = raw.data ?? raw;
					let items = [];
					if (Array.isArray(payload)) items = payload;
					else if (payload && Array.isArray(payload.items)) items = payload.items;
					let link = '';
					if (items && items.length) {
						const item = items[0];
						if (typeof item === 'string') link = item;
						else link = item.id || item.url || item.link || item.value || item.text || '';
					} else if (typeof payload === 'string') {
						link = payload;
					}
					if (link) self.policyLink = link;
				}
			})
			.catch(() => {
				// ignore lookup errors silently
			});

	}
}
</script>

<style scoped></style>